// extracted by mini-css-extract-plugin
export default {"YesNoButton":"YesNoButton_YesNoButton__ctdRz","Yes":"YesNoButton_Yes__G0DFX","No":"YesNoButton_No__etGFB"};